import script from "./PairUp.vue?vue&type=script&setup=true&lang=js"
export * from "./PairUp.vue?vue&type=script&setup=true&lang=js"

import "./PairUp.vue?vue&type=style&index=0&id=0725d183&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0725d183"]])

export default __exports__